// apps/embed/config/mui-compiled-out/styles/ThemeProviderWithVars.js
//
// Stands in for @mui/material/esm/styles/ThemeProviderWithVars.js in the embed's build (config/stand-ins.cjs).
// MUI's ThemeProvider renders CssVarsProvider only for a theme with `colorSchemes`, and no widget creates one. The
// same exports as the real file; each throws, so a CSS-variables theme fails at once instead of rendering wrong.
function compiledOut() {
	throw new Error("MUI's CSS-variables theme provider (CssVarsProvider, useColorScheme) is compiled out of the embed: apps/embed/config/stand-ins.cjs");
}

export const CssVarsProvider = compiledOut;
export const useColorScheme = compiledOut;
export const getInitColorSchemeScript = compiledOut;
export const Experimental_CssVarsProvider = compiledOut;
